import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';

import PageHeaderSection from './pageHeaderSection';
import MountainInfoSection from './mountainInforSection';
import CombinedBarSection from './combinedBarSection';
import DiamondInfoSection from './diamondInforSection';

import './main.css';
import hyblockVideo from './images/Ziplyne Video.webm';
import graphic from './images/zip-editor.png';
import ziplyneImage from './images/ziplyne.svg';
import pendoImage from './images/pendo.svg';
import useMediaQuery from "@material-ui/core/useMediaQuery";

function Ziplyne_pendo() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif'
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Helmet>
                <title>Ziplyne vs Pendo</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>


                        <main>
                            <Parallax y={[-15, 15]}>
                                <PageHeaderSection screenIsSmall={screenIsSmall}>
                                    Does your in-app guide lead you everywhere...Except the summit?<br />Why not check out the view from the <b>Ziplyne!</b>
                                </PageHeaderSection>
                            </Parallax>
                            <MountainInfoSection
                                content={"At Ziplyne we understand that key to successful Digital Adoption is effective in-app guidance. That is why we’ve designed a product that seamlessly aligns our Zips/Guides to maximize your Product Adoption KPIs and shorten the path to your destination...And we know that your product will be constantly evolving so we’re built to grow, adapt and evolve with you."}
                                media={hyblockVideo}
                                hideParallax={screenIsSmall}
                            />
                            <CombinedBarSection
                                header={"We Listened...\nWe Built"}
                                content={"Ziplyne is designed to be easy to use and non-intrusive, and absolutely NO CODING is necessary for content creation."}
                                image={graphic}
                                videoHeader={"But don’t just take our word for it... Compare for yourself!"}
                                hideParallax={screenIsSmall}
                            />
                            <DiamondInfoSection
                                content={"And best of all, Ziplyne’s ease of use unlocks multiple new paths of value and productivity including lower TCO and greater scalability!"}
                                ziplyneImage={ziplyneImage}
                                pendoImage={pendoImage}
                            />
                        </main>


                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    )
        ;
}

export default Ziplyne_pendo;
